import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";

const SkipCustomerApprovalDialog = ({
  open,
  handleClose,
  onConfirm,
  loading,
}) => {
  const theme = useTheme();
  const [errorMsg, setErrorMessage] = useState(null);
  const [confirmText, setConfirmText] = useState(null);

  return (
    <Dialog
      keepMounted
      scroll={"paper"}
      maxWidth="sm"
      fullWidth={true}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Skip Customer Quote Approval</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Please confirm that you want to skip customer approval for this quote
          by entering "confirm"
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="confirm"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={() => {
            setConfirmText("");
            handleClose();
          }}
          loading={loading}
        >
          Back
        </LoadingButton>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={confirmText != "confirm"}
          onClick={onConfirm}
        >
          Skip
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default SkipCustomerApprovalDialog;
